import { Validators } from '@angular/forms';
import { Injectable } from "@angular/core";
@Injectable()
export class AppConstants {
    public static addressRegex = '^[^ ].*$';//"^[a-zA-ZÀ-ÿ0-9]+[a-zA-ZÀ-ÿ0-9\'.\\-\\,# ]*$";
    public static emailRegex = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";
    public static monthRegex = "^(0?[1-9]|1[012])$";
    public static passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[#?!@$%&*^+=()-])([A-Za-z0-9#?!@$%&*^+=()-])+$");
    public static nameRegEx = '^[a-zA-ZÀ-ÿ]+[a-zA-ZÀ-ÿ \'-]*$';//new RegExp('\[a-zà-ÿA-ZÀ-ÿ \]');
    public static numberRegex = '^[0-9]+$';
    public static numberRangeRegex = '^(1|[1-9][0-9]?|100)$';
    public static secondsRangeRegex = '^(5|[5-9]|[1-5][0-9]|60)$';
    public static cvvRegex = '^[0-9]{3,4}$';
    public static yearRegex = '^[1-9][0-9]{3}$';
    public static groupNameRegex = '^[a-zA-ZÁ-ÿ0-9]+[a-zA-ZÁ-ÿ0-9-_.,~@: ]*$';
    public static groupDescRegex = '^[a-zA-ZÁ-ÿ0-9]+[-a-zA-ZÁ-ÿ0-9-().:_;, ]*$';
    public static orgRegExp = '^[a-zA-ZÀ-ÿ0-9]+[a-zA-ZÀ-ÿ0-9 \'-.]*$';
    public static cancelSubRegExp = '^[a-zA-ZÀ-ÿ0-9]+[a-zA-ZÀ-ÿ0-9 \'.\n]*$';
    public static notiMsgRegExp = '^[a-zA-ZÀ-ÿ0-9]+[a-zA-ZÀ-ÿ0-9 \'-.()¿?¡!&%$@#":]*$';
    public static alphaRegex = '^[a-zA-ZÀ-ÿ]+[a-zA-ZÀ-ÿ ]*$';
    //public static placeRegex = /^[0-9]*[a-zA-ZÀ-ÿ]+[a-zA-ZÀ-ÿ0-9!@#$%^&*()_+\-=\[\]{};\':"\\|,.`~<>\/? ]*$/;
    public static cardNameRegex = '^[a-zA-ZÀ-ÿ]{2}[a-zA-ZÀ-ÿ ]*$';
    public static zipRegex = '^[0-9]{5}(?:-[0-9]{4})?$';
    public static icons = {"Accident":"https://maps.google.com/mapfiles/ms/icons/orange-dot.png","Fire":"https://maps.google.com/mapfiles/ms/icons/red-dot.png","Medical":"https://maps.google.com/mapfiles/ms/icons/green-dot.png","Security":"https://maps.google.com/mapfiles/ms/icons/blue-dot.png"};
    public static phoneRegEx = [Validators.maxLength(20),Validators.pattern('^[\+]?[0-9(]+[0-9-()) ]*')];
    public static phoneRegExReq = [Validators.required,Validators.maxLength(20),Validators.pattern('^[\+]?[0-9(]+[0-9-()) ]*')];
    public static extPhoneNumber = '^[\#0-9]?[0-9]+[0-9 ]?';
    public static noLeadingRegEx = '^[^\n ].*((.| |\n)*)';
    public static noPercentBackslash = /^[^\n \\%]+[^\\%]*$/;
    public tollFreeNumber = "1+833-827-2878‬";
    public static imageFormats = ["image/jpeg", "image/png"];
    public static defaultFields = ["first name", "last name", "profile picture", "phone number", "residence phone number", "email", "role", "date of birth", "gender", "address", "city", "state/province", "country", "primary contact name", "primary contact phone no.", "secondary contact name", "secondary contact phone no.", "nombre", "apellido", "foto de perfil", "número de teléfono", "teléfono de residencia", "correo electrónico", "rol", "fecha de nacimiento", "sexo", "dirección", "ciudad", "estado/provincia" , "país", "nombre de contacto primario", "#tel. del contacto primario", "nombre de contacto secundario", "#tel. del contacto secundario"];
    public static hourRange = {"00:00:00-01:00:00":"12:00 AM - 1:00 AM", "01:00:00-02:00:00":"1:00 AM - 2:00 AM", "02:00:00-03:00:00":"2:00 AM - 3:00 AM", "03:00:00-04:00:00":"3:00 AM - 4:00 AM", "04:00:00-05:00:00":"4:00 AM - 5:00 AM", "05:00:00-06:00:00":"5:00 AM - 6:00 AM", "06:00:00-07:00:00":"6:00 AM - 7:00 AM", "07:00:00-08:00:00":"7:00 AM - 8:00 AM", "08:00:00-09:00:00":"8:00 AM - 9:00 AM", "09:00:00-10:00:00":"9:00 AM - 10:00 AM", "10:00:00-11:00:00":"10:00 AM - 11:00 AM", "11:00:00-12:00:00":"11:00 AM - 12:00 PM", "12:00:00-13:00:00":"12:00 PM - 1:00 PM", "13:00:00-14:00:00":"1:00 PM - 2:00 PM", "14:00:00-15:00:00":"2:00 PM - 3:00 PM", "15:00:00-16:00:00":"3:00 PM - 4:00 PM", "16:00:00-17:00:00":"4:00 PM - 5:00 PM", "17:00:00-18:00:00":"5:00 PM - 6:00 PM", "18:00:00-19:00:00":"6:00 PM - 7:00 PM", "19:00:00-20:00:00":"7:00 PM - 8:00 PM", "20:00:00-21:00:00":"8:00 PM - 9:00 PM", "21:00:00-22:00:00":"9:00 PM - 10:00 PM", "22:00:00-23:00:00":"10:00 PM - 11:00 PM", "23:00:00-23:59:59":"11:00 PM - 12:00 AM"};
    public static hours = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
    public static minutes = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55","56", "57", "58", "59"];
    
    public sendOptions = [
        {id:"pushNotification",name:"notification.send_via_app"},
        {id:"emailNotification",name:"notification.send_via_email"},
        {id:"sms",name:"notification.send_via_sms"},
        {id:"voiceCall",name:"notification.send_via_voice"}
    ];

    public static MY_FORMATS = {
        parse: {
          dateInput: 'MM/YYYY',
        },
        display: {
          dateInput: 'MM/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
    };

    public static REASSIGN_MESSAGE = {
      EN: "Alert #{{ID}} was reassigned to {{AGENT}}",
      ES: "Alerta #{{ID}} fue reasignada a {{AGENT}}"
    }

    public static ATTENDED_ALERT_MESSAGE = {
      EN: "Alert #{{ID}} is being attended by {{AGENT}}",
      ES: "Alerta #{{ID}} está siendo atendida por {{AGENT}}"
    }

    public static CLOSED_ALERT_MESSAGE = {
      EN: "Alert #{{ID}} was attended by {{AGENT}}",
      ES: "Alerta #{{ID}} fue atendida por {{AGENT}}"
    }
}